export const RootPrefix = 'auth';
export const TwoFactorFormId = 'two_factor_form';
export const SignInOptionsFormId = 'sign_in_options_form';
export const SignInFormId = 'sign_in_form';
export const SignUpFormId = 'sign_up_form';
export const PasswordRecoveryFormId = 'password_recovery_form';
export const PasswordResetFormId = 'password_reset_form';
export const OtpFormId = 'otp_form';
export const OtpCodeLength = 6;
